/**
 * Workshop Utilities - Shared helper functions and components
 */
import { Badge } from '@/components/ui/badge';
import { 
  Edit, Users, Clock, CheckCircle, XCircle, AlertTriangle,
  Video, FileText, Image, Music, Link
} from 'lucide-react';

// Status badge configuration
const STATUS_CONFIG = {
  draft: { color: 'bg-gray-500', label: 'Draft', icon: Edit },
  pending_collaborator_approval: { color: 'bg-yellow-500', label: 'Awaiting Collaborators', icon: Users },
  pending_admin_approval: { color: 'bg-blue-500', label: 'Pending Approval', icon: Clock },
  approved: { color: 'bg-green-600', label: 'Approved', icon: CheckCircle },
  live: { color: 'bg-green-500', label: 'Live', icon: CheckCircle },
  rejected: { color: 'bg-red-500', label: 'Rejected', icon: XCircle },
  unpublished: { color: 'bg-gray-600', label: 'Unpublished', icon: AlertTriangle }
};

// Content type icons
const CONTENT_TYPE_ICONS = {
  video: Video,
  text: FileText,
  image: Image,
  audio: Music,
  link: Link,
  pdf: FileText
};

export const getStatusBadge = (status) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.draft;
  const Icon = config.icon;
  
  return (
    <Badge className={`${config.color} text-white`}>
      <Icon className="w-3 h-3 mr-1" />
      {config.label}
    </Badge>
  );
};

export const getContentTypeIcon = (type) => {
  const Icon = CONTENT_TYPE_ICONS[type] || FileText;
  return <Icon className="w-4 h-4" />;
};

// Fee model (June 2026): the buyer pays the listed price plus card processing
// (3% + $0.30). The platform's share comes out of the price, so a change to the
// percentage moves the creator's net and never reprices the buyer.
// The rate is admin-editable and can be overridden per workshop — pass it in.
export const DEFAULT_PLATFORM_FEE_PCT = 20;

export const calculatePricing = (price, feePct = DEFAULT_PLATFORM_FEE_PCT) => {
  const numPrice = parseFloat(price) || 0;
  const pct = Number.isFinite(parseFloat(feePct)) ? parseFloat(feePct) : DEFAULT_PLATFORM_FEE_PCT;
  const platformFee = numPrice * (pct / 100);
  const processingFee = numPrice * 0.03 + 0.30;
  return {
    platformFeePct: pct,
    platformFee,
    processingFee,
    youReceive: numPrice - platformFee,
    total: numPrice + processingFee,
  };
};
